<template>
<div class="range-slider">
	<div class="range-slider__input-area">
		<input class="range-slider__input" type="range" v-model="value" @input="handlerInput" :disabled="disabled" :min="+min" :max="+max" :step="+step">
		<div class="range-slider__progress" :style="{width: `${(value - min) * 100 / (max - min) }%`}"></div>
		<div class="range-slider__pointer" :style="{left: `${(value - min) * 100 / (max - min) }%`}">
			<div class="range-slider__value">{{value}}</div>
		</div>
	</div>
	<div class="range-slider__footer">
		<div class="range-slider__footer-item">{{ min }}</div>
		<div class="range-slider__footer-item">{{ max }}</div>
	</div>
</div>
</template>

<script>

export default {
	emits: [
		'update:model-value'
	],

	props: {
		min: {
			type: [Number, String],
			default: 0
		},

		max: {
			type: [Number, String],
			default: null
		},

		step: {
			type: [Number, String],
			default: 1
		},

		modelValue: {
			type: [Number, String],
			default: null
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		modelValue(state) {
			this.value = state
		}
	},

	data() {
		return {
			value: null
		}
	},

	mounted() {
		this.value = +this.modelValue;
	},

	methods: {
		handlerInput() {
			this.$emit('update:model-value', this.value);
		}
	}
}

</script>